
import {   
  FacebookIcon,
  GooglePlusIcon,
  GlassdoorIcon,
  InstagramIcon,
  LinkedInIcon,
  TumblrIcon,
  TwitterIcon,
  YoutubeIcon 
} from './external_modern_icons.jsx';


const socialIconsByServiceName = {
  facebook: FacebookIcon,
  'google-plus': GooglePlusIcon,
  glassdoor: GlassdoorIcon,
  instagram: InstagramIcon,
  linkedin: LinkedInIcon,
  twitter: TwitterIcon,
  youtube: YoutubeIcon
};

const socialLinkDisplayNameByServiceName = {
  facebook: 'Facebook',
  'google-plus': 'Google Plus',
  glassdoor: 'Glassdoor',
  instagram: 'Instagram',
  linkedin: 'LinkedIn',
  twitter: 'Twitter',
  youtube: 'YouTube'
};

export { 
  socialLinkDisplayNameByServiceName,
  socialIconsByServiceName,
  FacebookIcon,
  GooglePlusIcon,
  GlassdoorIcon,
  InstagramIcon,
  LinkedInIcon,
  TumblrIcon,
  TwitterIcon,
  YoutubeIcon
};

export default {
  FacebookIcon,
  GooglePlusIcon,
  GlassdoorIcon,
  InstagramIcon,
  LinkedInIcon,
  TumblrIcon,
  TwitterIcon,
  YoutubeIcon
};
